import { useContext } from 'react';

import {
  InviteGuestsModalContext,
  InviteGuestsModalContextValue
} from '../InviteGuestsModalContext';

export const useInviteGuestsModalContext = (): InviteGuestsModalContextValue => {
  const context = useContext(InviteGuestsModalContext);

  if (!context) {
    throw new Error('useInviteGuestsModalContext must be used within an InviteGuestsModalProvider');
  }

  return context;
};
